import type { EntityHistoryFieldLabels } from '@/components/history'

export const WORK_ITEM_HISTORY_FIELD_LABELS: EntityHistoryFieldLabels = {
  Title: 'Title',
  Description: 'Description',
  Epic: 'Epic',
  Feature: 'Feature',
  TechnicalApproach: 'Technical Approach',
  Status: 'Status',
  AssignedToUserId: 'Assigned To',
  ExternalSource: 'External Source',
  ExternalId: 'External ID',
  ExternalUrl: 'External URL',
}
